// extracted by mini-css-extract-plugin
module.exports = {"link-wrapper":"LinkWithIcon_link-wrapper__Jt2J3","link":"LinkWithIcon_link__idY_m"};